import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add and edit custom fields for cart in commercetools
 */
export const mutationEditCustomCartType = {
  async editCustomCartType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const key = "customCartTypeKey"

    const customCartType = (await commerceApi.types().withKey({ key }).get().execute())?.body

    if (!customCartType) throw new Error("Custom type does not exist")

    const requestBody = {
      version: customCartType.version,
      actions: [
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "createdByEmployeeNumber",
            label: {
              "de-DE": "Erstellt nach Mitarbeiternummer",
              "en-US": "Created by employee number",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: {
              name: "LocalizedEnum",
              values: [
                {
                  key: "individual",
                  label: {
                    "de-DE": "Einzelrechnung",
                    "en-US": "Individual invoice",
                  },
                },
                {
                  key: "collective",
                  label: {
                    "de-DE": "Kundeneinstellung / Sammelrechnung",
                    "en-US": "Customer setting / collective invoice",
                  },
                },
              ],
            },
            name: "collectiveInvoiceType",
            label: {
              "de-DE": "Sammelrechnungsart",
              "en-US": "Collective Invoice Type",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: {
              name: "LocalizedEnum",
              values: [
                {
                  key: "order",
                  label: {
                    "de-DE": "Auftrag",
                    "en-US": "Order",
                  },
                },
                {
                  key: "cashSale",
                  label: {
                    "de-DE": "Barverkauf",
                    "en-US": "Cash sale",
                  },
                },
                {
                  key: "offer",
                  label: {
                    "de-DE": "Angebot",
                    "en-US": "Offer",
                  },
                },
                {
                  key: "reservation",
                  label: {
                    "de-DE": "Reservierung",
                    "en-US": "Reservation",
                  },
                },
              ],
            },
            name: "documentType",
            label: {
              "de-DE": "Belegart",
              "en-US": "Document type",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "sendInfoMail",
            label: {
              "de-DE": "Bestätigung versenden",
              "en-US": "Send confirmation",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "admNumber",
            label: {
              "de-DE": "Verkäufer-Nr.",
              "en-US": "Seller no.",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Date" },
            name: "deliveryDate",
            label: {
              "de-DE": "Lieferdatum",
              "en-US": "Delivery date",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Date" },
            name: "paymentTill",
            label: {
              "de-DE": "Valuta-Datum",
              "en-US": "Payment till",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Date" },
            name: "validTill",
            label: {
              "de-DE": "Gültig bis",
              "en-US": "Valid till",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "additionalInformationOne",
            label: {
              "de-DE": "Weitere Informationen eins",
              "en-US": "Additional information one",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "additionalInformationTwo",
            label: {
              "de-DE": "Weitere Informationen zwei",
              "en-US": "Additional information two",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "additionalInformationThree",
            label: {
              "de-DE": "Weitere Informationen drei",
              "en-US": "Additional information three",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "deliveryObjectDetails",
            label: {
              "de-DE": "Objektdetails",
              "en-US": "Delivery object details",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "emailMessage",
            label: {
              "de-DE": "E-Mail Nachricht",
              "en-US": "Email Message",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "emailSubject",
            label: {
              "de-DE": "E-Mail Betreff",
              "en-US": "Email Subject",
            },
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "contactPersons",
            label: {
              "de-DE": "Kontaktpersonen",
              "en-US": "Contact Persons",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "customerExternalId",
            label: {
              "de-DE": "Externe Kunden-ID",
              "en-US": "External Customer ID",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "branchId",
            label: {
              "de-DE": "Filial-ID",
              "en-US": "Branch ID",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "orderText",
            label: {
              "de-DE": "Bestelltext",
              "en-US": "Order Text",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "orderNumber",
            label: {
              "de-DE": "Bestellnummer",
              "en-US": "Order Number",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "printAdmNumber",
            label: {
              "de-DE": "Druck-Verkäufer-Nr.",
              "en-US": "Seller no. for printing",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "displayRecommendedSalesPrice",
            label: {
              "de-DE": "empf. VK anzeigen",
              "en-US": "Display recommended sales price",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "printOffer",
            label: {
              "de-DE": "Angebot drucken",
              "en-US": "Print offer",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "reservationNumber",
            label: {
              "de-DE": "ReservierungsNummer",
              "en-US": "Reservation number",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "picklistNumber",
            label: {
              "de-DE": "Pickliste Nummer",
              "en-US": "Picklist number",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "costUnit",
            label: {
              "de-DE": "Kostenträger",
              "en-US": "Cost Unit",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "togglePicklist",
            label: {
              "de-DE": "Pickliste erstellen",
              "en-US": "Create picklist",
            },
            required: false,
          },
        },
      ],
    }

    try {
      await commerceApi
        .types()
        .withKey({ key })
        .post({ body: JSON.stringify(requestBody) })
        .execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
